import React from 'react';
import {List, ListItem} from 'material-ui/List';
import Checkbox from 'material-ui/Checkbox';
import FlatButton from 'material-ui/FlatButton';
import {createSummaryRpt} from '../Reports/SectionSummaryRpt';
import {RadioButtonGroup, RadioButton} from 'material-ui/RadioButton'
import Divider from 'material-ui/Divider'
import {createAnswerRpt} from '../Reports/AnswersRpt'
import { makeTitle } from '../reducer';
import {Tabs, Tab} from 'material-ui/Tabs';

const listItemStyle = {
  paddingTop:5,
  paddingBottom:5
}

const chkBoxStyle = {
  top:0
}

class ReportGenerator extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      options: props.options,
      selectedItems: [],
      pageFormat: 'a4',
      pageOrientation: 'l',
      includeNotes: true,
      includeDesc: true,
      includeCrit: true,
      includeCavs: true,
      includeBookmarks: true,
      tabValue: props.rptType
    }
  }

  handleTabChange = (tabValue) => {
    this.setState({
      tabValue: tabValue,
    });
  };

  render(){
    var optsNeeded = (this.props.rptType === "results");
    var answerRpt = (this.props.rptType === "answers")

    if(optsNeeded){
      var optionList = this.state.options.map((option) =>{
        var catTitle = this.props.section === "assessment" ? <div style={{fontSize:14}}>Assessment Category: <i>{option.inputCategory.title}</i>, Assessment Output: <i>{option.category.title}</i></div> : <div style={{fontSize:14}}>Category: <i>{option.category.title}</i></div>;
        var optTitle = this.props.starred.indexOf(option.id) === -1 ? option.title : <div><b>Top Option: </b> {option.title} </div>
        return(
          <ListItem key={option.id} primaryText={<div style={{marginTop:-8}}>{optTitle}{catTitle}</div>} leftCheckbox={<Checkbox onCheck={this.onCheck.bind(this, option.id)} checked={this.state.selectedItems.includes(option.id)} />} />
        );
      })
    }

    var pageFormatLabelMargin = 43; // how much margin needed to match page Orit label size

    return(
      <div>

        <Divider />
        <div style={{display: 'flex', alignItems:'center', marginTop:10}}>
          <div style={{color:'black', marginRight:10}}>Page Orientation:</div>
          <RadioButtonGroup name="pageOrientation" defaultSelected="l" onChange={this.onPageOrientationChange.bind(this)}>
            <RadioButton value="l" label="Landscape" style={{ display: 'inline-block', width: '125px' }} />
            <RadioButton value="p" label="Portrait" style={{ display: 'inline-block', width: '125px' }} />
          </RadioButtonGroup>
        </div>

        <div style={{display: 'flex', alignItems:'center'}}>
          <div style={{color:'black', marginRight:pageFormatLabelMargin+10}}>Paper Size:</div>
          <RadioButtonGroup name="pageFormat" defaultSelected="a4" onChange={this.onPageFormatChange.bind(this)}>
            <RadioButton value="a4" label="A4" style={{ display: 'inline-block', width: '125px' }} />
            <RadioButton value="letter" label="Letter" style={{ display: 'inline-block', width: '125px' }} />
          </RadioButtonGroup>
        </div>

        {
         answerRpt ? (
           <List>
             <ListItem style={listItemStyle} primaryText="Include Notes" key={"incNotes"} leftCheckbox=<Checkbox checked={this.state.includeNotes} onCheck={this.onNotesChecked.bind(this)} style={chkBoxStyle} /> />
             <ListItem style={listItemStyle} primaryText="Include Bookmarks" key={"incBMs"} leftCheckbox=<Checkbox checked={this.state.includeBookmarks} onCheck={this.onBookmarksChecked.bind(this)} style={chkBoxStyle} /> />
           </List>) :
           (
            <Tabs
              value={this.state.tabValue}
              onChange={this.handleTabChange}
            >
              <Tab label="Results" value="results">
                <div style={{display: 'flex', alignItems:'center'}}>
                  <div style={{color:'black', marginRight:pageFormatLabelMargin+10}}>Include for each option (if available):</div>
                  <List>
                    <ListItem key={"incDesc"} primaryText="Description" style={listItemStyle} leftCheckbox=<Checkbox style={chkBoxStyle} checked={this.state.includeDesc} onCheck={this.onDescChecked.bind(this)} /> />
                    <ListItem key={"incNotes"} primaryText="Notes" style={listItemStyle} leftCheckbox=<Checkbox style={chkBoxStyle} checked={this.state.includeNotes} onCheck={this.onNotesChecked.bind(this)} /> />
                    <ListItem key={"incCrit"} primaryText="Criteria" style={listItemStyle} leftCheckbox=<Checkbox style={chkBoxStyle} checked={this.state.includeCrit} onCheck={this.onCritChecked.bind(this)} /> />
                    <ListItem key={"incCavs"} primaryText="Caveats" style={listItemStyle} leftCheckbox=<Checkbox style={chkBoxStyle} checked={this.state.includeCavs} onCheck={this.onCavsChecked.bind(this)} /> />
                  </List>
                </div>

                <Divider />


                <div>
                  The list of options below is what is currently displayed in the results page. To see different options return to the results and change the filters or sorting.
                  Check which options to include in the report.
                  <br/>
                  <FlatButton onClick={this.onSelectAll.bind(this)} label="Select All" />
                  <FlatButton onClick={this.onUnselectAll.bind(this)} label="Unselect All" />
                  <List>
                      {optionList}
                  </List>
                </div>
              </Tab>

              <Tab label="Answers" value="answers">
                <List>
                  <ListItem style={listItemStyle} primaryText="Include Notes" key={"incNotes"} leftCheckbox=<Checkbox checked={this.state.includeNotes} onCheck={this.onNotesChecked.bind(this)} style={chkBoxStyle} /> />
                  <ListItem style={listItemStyle} primaryText="Include Bookmarks" key={"incBMs"} leftCheckbox=<Checkbox checked={this.state.includeBookmarks} onCheck={this.onBookmarksChecked.bind(this)} style={chkBoxStyle} /> />
                </List>
              </Tab>
            </Tabs>)
          }
      </div>
    );
  }

  onPageOrientationChange(e, value){
    this.setState({
      pageOrientation: value
    });
  }

  onPageFormatChange(e, value){
    this.setState({
      pageFormat: value
    })
  }

  onCheck(optionID){
    var index = this.state.selectedItems.indexOf(optionID);
    var newItems = this.state.selectedItems.slice();
    if(index === -1){
      //item not in list, therefore checking box and need to add ID to selectedItems
      newItems.push(optionID);
    }else{
      //item in the list, unchecking item, remove from list
      newItems.splice(index, 1);
    }

    this.setState({
      selectedItems: newItems
    })
  }

  onNotesChecked(){
    this.setState({
      includeNotes: !this.state.includeNotes
    })
  }

  onBookmarksChecked(){
    this.setState({
      includeBookmarks: !this.state.includeBookmarks
    })
  }

  onDescChecked(){
    this.setState({
      includeDesc: !this.state.includeDesc
    })
  }

  onCritChecked(){
    this.setState({
      includeCrit: !this.state.includeCrit
    })
  }

  onCavsChecked(){
    this.setState({
      includeCavs: !this.state.includeCavs
    })
  }

  onSelectAll(){
    let optIDs = this.state.options.map((option) => {
            return parseInt(option.id);
          });
    this.setState({
      selectedItems: optIDs
    })
  }

  onUnselectAll(){
    this.setState({
      selectedItems: []
    })
  }

  genReports(rptType){
    if(rptType === "results"){
      createSummaryRpt(this.state.selectedItems, this.state.options, this.props.section, makeTitle(this.props), this.state.pageOrientation, this.state.pageFormat, this.props.answers, this.props.answerTextLookup, this.props.questionLookup, this.props.notesList, this.state.includeDesc, this.state.includeNotes, this.state.includeCrit, this.state.includeCavs, this.props.starred, this.props.translation);
    } else if(rptType === "answers"){
      createAnswerRpt(makeTitle(this.props), this.state.pageOrientation, this.state.pageFormat, this.props.answers, this.props.monitoringQuestions, this.props.assessmentQuestions, this.props.controlRulesQuestions, this.props.categories, this.props.sections, this.state.includeNotes, this.state.includeBookmarks, this.props.translation)
    }
  }
}
export default ReportGenerator;
